import BaseService from './BaseService';

export default class extends BaseService {
  static index(options = {}) {
    const url = super.url('spray_requests');

    if (options.contractId) {
      url.searchParams.append('spray_requests', options.contractId);
    }

    return super
      .get(url)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        return Promise.reject(error.response.data);
      });
  }
}
